
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.75 8.15L2.125 5.525a.738.738 0 00-1.05 0 .738.738 0 000 1.05l3.143 3.142a.747.747 0 001.057 0l7.95-7.942a.738.738 0 000-1.05.738.738 0 00-1.05 0L4.75 8.15z","fill":"#fff"}})])
          )
        }
      }
    